// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__2aKvT","Hero_center":"Hero_Hero_center__34YTu"};